import React from "react";
import FeatureBlock from "./FeatureBlock";
import { FaGlobe, FaShieldAlt, FaHeadset } from "react-icons/fa";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const FeatureSection = () => (
  <div className="dg__live__chart bg__color--4 pt--30 pl--30 pr--30">
    <motion.div
      className="row"
      variants={container}
      initial="hidden"
      animate="show"
    >
      {[
        { icon: FaGlobe, title: "Beginner-Focused Learning" },
        { icon: FaShieldAlt, title: "Secure & Transparent" },
        { icon: FaHeadset, title: "All-in-One Platform" },
      ].map((itemData, index) => (
        <motion.div
          className="col-md-4"
          key={index}
          variants={item}
          whileHover={{ scale: 1.05 }}
        >
          <div className="feature-card">
            <FeatureBlock {...itemData} />
          </div>
        </motion.div>
      ))}
    </motion.div>
  </div>
);

export default FeatureSection;
